import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

import { makeQueryString } from '../../util';
import * as Ticket from './Ticket';
import * as User from './User';

export type V = {
  '@id': string;
  '@type': 'DailyTask';
  ticket: Ticket.BaseView & {
    company: {
      '@id': string;
      '@type': 'Company';
      slug: string;
      name: string;
      backgroundColor: string | null;
    };
    skills: Array<{
      '@id': string;
      '@type': 'TicketSkill';
      id: string;
      type: string;
      approved: boolean | null;
      assignee: User.BaseView | null;
      status: string | null;
    }>;
    priority: string | null;
  };
  timeLoggedToday: number;
  isCompleted: boolean;
};

export function useReadCollection(
  queryParams?: { user?: string },
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V>>(
    `/daily-tasks${makeQueryString(queryParams)}`,
    options
  );
}
